if ($('main').hasClass('client')) {
    // var swiper1 = {
    //     width: Infinity,
    //     swiperContainer: '.key__swiper',
    //     swiperContainerWrap: '.key__swiper-wrap',
    //     swiperContainerSlide: '.key__swiper-slide',
    //     swiperVariable: undefined,
    //     swiperUpdateTime: undefined,
    //     swiperSettings: {
    //         slidesPerView: 'auto',
    //         speed: 500,
    //         watchOverflow: true,
    //         spaceBetween: 8,
    //         slidesOffsetAfter: 16,
    //         loop: false,
    //         freeMode: true,
    //         navigation: {
    //             nextEl: '.key__swiper-next',
    //             prevEl: '.key__swiper-prev',
    //         },
    //         breakpoints: {
    //             991: {
    //                 slidesPerView: 1,
    //                 spaceBetween: 20,
    //                 slidesOffsetAfter: 0
    //             },
    //         }
    //     },
    // }

    var swiper2 = {
        width: Infinity,
        swiperContainer: '.rating__slider',
        swiperContainerWrap: '.rating__slider-wrap',
        swiperContainerSlide: '.rating__slider-el',
        swiperVariable: undefined,
        swiperUpdateTime: undefined,
        swiperSettings: {
            slidesPerView: 'auto',
            speed: 500,
            watchOverflow: true,
            spaceBetween: 12,
            loop: true,
            freeMode: true,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: '.rating__slider-next',
                prevEl: '.rating__slider-prev',
            },
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 29
                },
            }
        },
    }

    // initCustomSwiper(swiper1);
    initCustomSwiper(swiper2);
    $(window).resize(function () {
        // initCustomSwiper(swiper1);
        initCustomSwiper(swiper2);
    });

    $(document).on('click', '.faq__el', function () {
        if (!$(this).hasClass('active')) {
            $('.faq__el.active').removeClass('active').find('.faq__el-text').slideUp();
            $(this).addClass('active').find('.faq__el-text').slideDown();
        } else {
            $(this).removeClass('active').find('.faq__el-text').slideUp();
        }
    });




    var galerySwiper = [];
    var keySwiper = [];

    // Инициализация свайперов
    function gallerySwiperInit() {
        $(document).find('.galery__slider').each(function (e) {

            $(this).removeClass("number" + e).addClass("number" + e);
            $(this).siblings('.galery__slider-nav').addClass("number" + e);

            galerySwiper[e] = {
                width: Infinity,
                swiperContainer: '.swiper-container.number' + e,
                swiperContainerWrap: '.swiper-container.number' + e + ' .galery__slider-wrap',
                swiperContainerSlide: '.swiper-container.number' + e + ' .galery__slider-el',
                swiperVariable: undefined,
                swiperUpdateTime: undefined,
                swiperSettings: {
                    slidesPerView: 'auto',
                    speed: 500,
                    watchOverflow: true,
                    spaceBetween: 8,
                    slidesOffsetAfter: 16,
                    freeMode: true,
                    loop: false,
                    navigation: {
                        nextEl: '.galery__slider-nav.number' + e + ' .galery__slider-next',
                        prevEl: '.galery__slider-nav.number' + e + ' .galery__slider-prev',
                    },
                    breakpoints: {
                        991: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                            slidesOffsetAfter: 0,
                        },
                    }
                },
            };
            initCustomSwiper(galerySwiper[e]);
            $(window).resize(function () {
                initCustomSwiper(galerySwiper[e]);
            });

            setTimeout(function () {
                galerySwiper[e].swiperVariable.update();
            }, 200);
        });
    }

    console.log($('.key__swiper'));

    // Key swipers
    function gallerySwiperInit1() {
        $('.key__swiper').each(function (e) {

            $(this).removeClass("number" + e).addClass("number" + e);
            $(this).siblings('.key__swiper-nav').addClass("number" + e);

            keySwiper[e] = {
                width: Infinity,
                swiperContainer: '.key__swiper.number' + e,
                swiperContainerWrap: '.key__swiper.number' + e + ' .key__swiper-wrap',
                swiperContainerSlide: '.key__swiper.number' + e + ' .key__swiper-slide',
                swiperVariable: undefined,
                swiperUpdateTime: undefined,
                swiperSettings: {
                    slidesPerView: 'auto',
                    speed: 500,
                    watchOverflow: true,
                    spaceBetween: 8,
                    slidesOffsetAfter: 16,
                    loop: false,
                    freeMode: true,
                    navigation: {
                        nextEl: '.key__swiper-nav.number' + e + ' .key__swiper-next',
                        prevEl: '.key__swiper-nav.number' + e + ' .key__swiper-prev',
                    },
                    breakpoints: {
                        991: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                            slidesOffsetAfter: 0
                        },
                    }
                },
            };
            initCustomSwiper(keySwiper[e]);
            $(window).resize(function () {
                initCustomSwiper(keySwiper[e]);
            });

            setTimeout(function () {
                keySwiper[e].swiperVariable.update();
            }, 200);
        });
    }

    gallerySwiperInit();
    gallerySwiperInit1();

    // Расположение кнопки слайдера Под ключ
    $(window).on('load resize', function (e) {
        $('.key__swiper').each(function () {

            var height = Number($(this).css('height').replaceAll('px', ''));
            $(this).siblings('.key__swiper-nav').css('top', height / 2);

        })

    })

    // Показать скрытые слайдеры

    // $('.galery__btn').on('click', function (e) {
    //     e.preventDefault();

    //     // Скрытие кнопки
    //     $(this).hide();

    // Апдейт свайперов
    // $('.galery__slider').each(function (e) {
    //     setTimeout(function () {
    //         galerySwiper[e].swiperVariable.update();
    //     }, 260);
    // });

    // });



    $(document).on('click', '.fancybox-slide', function () {
        $.fancybox.close();
    })


}

$('[data-fancybox]').fancybox({
    clickOutside: "close",
    clickSlide: "close",
});

// Клик по элементам фансибокса вне свайпера
// $(document).on('click', '.galery__slider-el', function (e) {
//     e.preventDefault();

//     var $this = $(this);
//     $this.parents('.galery__wrap').find('.galery__hidden-fancy a[data-num=' + $this.data('num') + ']').click();
// });
